export const APP_ROLES = ['client', 'courier', 'restaurant', 'admin']

const rawRole = process.env.VUE_APP_ROLE

function resolveRole() {
  if (APP_ROLES.includes(rawRole)) {
    return rawRole
  }
  if (process.env.NODE_ENV !== 'production') {
    if (rawRole) {
      console.warn(
        `[env] Invalid VUE_APP_ROLE="${rawRole}". Expected one of: ${APP_ROLES.join(', ')}. Using "client".`,
      )
    }
    return 'client'
  }
  throw new Error(
    `[env] VUE_APP_ROLE must be one of ${APP_ROLES.join(', ')} in production build. Got: "${rawRole}".`,
  )
}

export const APP_ROLE = resolveRole()

export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || ''

export const TELEGRAM_BOT_USERNAME =
  process.env.VUE_APP_TELEGRAM_BOT_USERNAME || 'deliverlybot'

export const TELEGRAM_FLOW_ID =
  process.env.VUE_APP_TELEGRAM_FLOW_ID || '6a6330d829b9a8a1120de446'
